import { render, staticRenderFns } from "./EinstellungenAuswahlwerte.vue?vue&type=template&id=73725184"
import script from "./EinstellungenAuswahlwerte.vue?vue&type=script&lang=js"
export * from "./EinstellungenAuswahlwerte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports